import React from "react";

interface Props {
  text: string;
}

function FormSubmitButton(props: Props) {
  const { text } = props;

  return (
    <button className="form-submit-btn" type="submit">
      {text}
    </button>
  );
}

export default FormSubmitButton;
